import { createAtomState } from '@/ui/utilities/state/jotai/utils/createAtomState';

export const isSidePanelOpenState = createAtomState<boolean>({
  key: 'isSidePanelOpenState',
  defaultValue: false,
});
